import React from 'react'

/**
 * Подсветка найденных слов в тексте желтым цветом
 * @param text - текст для подсветки
 * @param searchText - текст поиска
 * @returns JSX элемент с подсветкой
 */
export function highlightText(text: string | null | undefined, searchText: string | null | undefined): React.ReactNode {
  if (!text || !searchText || !searchText.trim()) {
    return text || ''
  }

  const searchLower = searchText.toLowerCase().trim()
  const textStr = String(text)
  const textLower = textStr.toLowerCase()

  // Если текст не содержит искомое слово, возвращаем как есть
  if (!textLower.includes(searchLower)) {
    return textStr
  }

  // Разбиваем текст на части и выделяем найденные слова
  const parts: (string | React.ReactElement)[] = []
  let lastIndex = 0
  let index = textLower.indexOf(searchLower, lastIndex)

  while (index !== -1) {
    // Добавляем текст до найденного слова
    if (index > lastIndex) {
      parts.push(textStr.substring(lastIndex, index))
    }

    // Добавляем найденное слово с подсветкой
    parts.push(
      <mark key={index} style={{ backgroundColor: '#ffeb3b', padding: '0 2px', borderRadius: '2px' }}>
        {textStr.substring(index, index + searchLower.length)}
      </mark>
    )

    lastIndex = index + searchLower.length
    index = textLower.indexOf(searchLower, lastIndex)
  }

  // Добавляем оставшийся текст
  if (lastIndex < textStr.length) {
    parts.push(textStr.substring(lastIndex))
  }

  return <>{parts}</>
}

/**
 * Подсветка найденных слов в тексте (для нескольких слов поиска)
 * @param text - текст для подсветки
 * @param searchText - текст поиска (может содержать несколько слов)
 * @returns JSX элемент с подсветкой
 */
export function highlightTextMultiple(text: string | null | undefined, searchText: string | null | undefined): React.ReactNode {
  if (!text || !searchText || !searchText.trim()) {
    return text || ''
  }

  const textStr = String(text)
  const searchWords = searchText
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0)

  if (searchWords.length === 0) {
    return textStr
  }

  // Проверяем, содержит ли текст хотя бы одно из слов поиска
  const textLower = textStr.toLowerCase()
  const hasMatch = searchWords.some(word => textLower.includes(word))

  if (!hasMatch) {
    return textStr
  }

  // Создаем регулярное выражение для поиска всех слов
  const regex = new RegExp(`(${searchWords.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi')
  
  const parts: (string | React.ReactElement)[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  while ((match = regex.exec(textStr)) !== null) {
    // Добавляем текст до найденного слова
    if (match.index > lastIndex) {
      parts.push(textStr.substring(lastIndex, match.index))
    }

    // Добавляем найденное слово с подсветкой
    parts.push(
      <mark key={match.index} style={{ backgroundColor: '#ffeb3b', padding: '0 2px', borderRadius: '2px' }}>
        {match[0]}
      </mark>
    )

    lastIndex = match.index + match[0].length
  }

  // Добавляем оставшийся текст
  if (lastIndex < textStr.length) {
    parts.push(textStr.substring(lastIndex))
  }

  return <>{parts}</>
}

